'use client'

import { useEffect } from 'react'
import * as Sentry from '@sentry/nextjs'
import { Button } from '@/components/ui/button'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error('Settings error:', error)
    Sentry.captureException(error)
  }, [error])

  return (
    <div className="flex min-h-[40vh] items-center justify-center">
      <div className="rounded-2xl border border-border bg-background p-8 text-center">
        <h2 className="mb-2 text-lg font-semibold text-foreground">Something went wrong</h2>
        <p className="mb-6 text-sm text-muted-foreground">Please try again, or refresh the page.</p>
        <Button onClick={reset} variant="outline">
          Try again
        </Button>
      </div>
    </div>
  )
}
